import type { TaskStatus } from '@interfaces/IScheduler';

// The plan status's i18n keys are shared with the mobile app; the pill's paint
// is the web's.
export { STATUS_KEY } from '@d-orca/shared/client/activities';

/** CSS-module class-name suffix for each status pill (e.g. `statusDone`). */
export const STATUS_CLASS: Record<TaskStatus, string> = {
  planned: 'statusPlanned',
  blocked: 'statusBlocked',
  done: 'statusDone',
};
